import { OnboardingModeEnum } from 'modules/onboarding/types/onboarding-mode.enum';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonProps } from 'shared/components/Button/Button';
import { useOnboardingMode } from 'shared/hooks/useOnboardingMode';
import { useSitemap } from 'shared/hooks/useSitemap';

interface ExtractionErrorOnboardingRedirectButtonProps {
  label: string;
  variant?: ButtonProps['variant'];
  className?: string;
  onRedirect?: () => void;
}

export const ExtractionErrorOnboardingRedirectButton: FC<
  ExtractionErrorOnboardingRedirectButtonProps
> = ({ label, variant, className, onRedirect }) => {
  const navigate = useNavigate();
  const sitemap = useSitemap();
  const { updateOnboardingMode, loading } = useOnboardingMode();

  const handleClick = useCallback(async () => {
    await updateOnboardingMode(OnboardingModeEnum.Manual);
    if (onRedirect) {
      onRedirect();
    }
    navigate(sitemap.onboarding());
  }, [navigate, sitemap, onRedirect]);

  return (
    <Button
      variant={variant}
      onClick={handleClick}
      loading={variant !== 'text' ? loading : undefined}
      disabled={loading}
      className={className}
      name="extractionErrorConfirmButton"
    >
      {label}
    </Button>
  );
};
